module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dashboard"
  }, [_c('aside', {
    staticClass: "sidebar",
    class: {
      'sidebar-visible': _vm.isActive
    }
  }, [_c('div', [_c('div', {
    staticClass: "sidebar--header"
  }, [_c('a', [_vm._v(_vm._s(_vm.team))])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar--links"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/activity"
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v("Activity")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/reports"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v("Reports")])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin"
    }
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  }), _vm._v("Admin")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v("Settings")])], 1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "main-content",
    class: {
      'push-content': _vm.isActive
    }
  }, [_c('header', [_c('nav', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "header--left"
  }, [_c('button', {
    staticClass: "hamburger hamburger--slider dashboard-hamburger",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showMenu
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('a', [_vm._v("Worklogs")]), _vm._v(" "), _c('div', {
    staticClass: "headway-app"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "header--right"
  }, [_c('div', {
    staticClass: "cog"
  }, [_c('p', [_c('a', {
    on: {
      "click": function($event) {
        _vm.signOut()
      }
    }
  }, [_vm._v("Logout")])])]), _vm._v(" "), _c('div', {
    staticClass: "username"
  }, [_c('p', [_vm._v(_vm._s(_vm.username))])])])])])])]), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hamburger-box"
  }, [_c('span', {
    staticClass: "hamburger-inner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7374b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 381
// module chunks = 1